interface BangerButtonProps {
  count: number;
  bangered: boolean;
  busy?: boolean;
  placement: "card" | "modal";
  onBanger: () => void;
}

export function BangerButton({ count, bangered, busy = false, placement, onBanger }: BangerButtonProps) {
  const label = bangered
    ? `Marked as a Banger. ${count} ${count === 1 ? "Banger" : "Bangers"}`
    : `Mark as a Banger. ${count} ${count === 1 ? "Banger" : "Bangers"}`;

  return (
    <button
      type="button"
      className={`clip-banger-button clip-banger-${placement}${bangered ? " is-bangered" : ""}${busy ? " is-busy" : ""}`}
      onClick={onBanger}
      aria-label={label}
      aria-pressed={bangered}
      disabled={bangered || busy}
      title={bangered ? "You marked this as a Banger" : "Mark as a Banger"}
    >
      <span className="clip-banger-fire" aria-hidden="true">🔥</span>
      <span className="clip-banger-count">{count}</span>
    </button>
  );
}
